import React from 'react'
import { useCallback, useState, useRef, useEffect, useMemo, RefObject } from 'react'
import { Services } from '@/services/services'
import { useNavigate, useParams } from 'react-router-dom'

import { Translates } from '@/services/repository/i18n'
import { CurrentSession } from '@/services/repository/session'
import { MainPageLayout } from '@/components/layout/MainLayout'
import { Machine } from '@/services/model/machine'
import { MachinePath } from '@/pages/communal/machine/Common'
import { BackButton } from '@/components/layout/NavBar'
import { ContactBox } from '@/components/contact/Contact'
import { machineRentPageContacts } from '@/env/contact'

import { ContactPageBody } from '@/components/contact/PageBody'

export const CommunalMachineRentPage = ({ services, session }: { services: Services, session?: CurrentSession }) => {
  const mid = useParams().mid
  const [machine, setMachine] = useState<Machine>()
  const [translates, setTranslates] = useState<Translates>()

  const refreshData = () => {
    fetch(`/api/communal/machines/byid/${mid}`).then((response) => {
      return response.json()
    }).then((data) => {
      setMachine(data)
    })
  }

  useEffect(() => {
    if (session) {
      setTranslates(session.translates)
      return
    }
    services.i18n.get('main').then(setTranslates)
  }, [session])

  useEffect(() => {
    refreshData()
  }, [mid])

  if (translates === undefined) {
    return <div className='spinner'></div>
  }

  if (machine === undefined || translates === undefined) {
    return <div className='spinner'></div>
  }

  return <MainPageLayout pageName='communal-dashboard-rent' services={services} translates={translates} session={session} path={[...MachinePath({ session, translates, machine }), {
    title: translates.for(`page.machinerent.title`)
  }]}
    navbarLeft={<BackButton services={services} translates={translates} fallbackUrl={`/communal/machine/${mid}`} />}>
    <ContactPageBody title='page.contact.title' contacts={machineRentPageContacts} translates={translates} />
  </MainPageLayout>
}
